import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import useStore from "../store/useStore";
import { useLocation } from "react-router-dom";

export default function PalabrasCarousel() {
  const { clientes, fetchClientes } = useStore();
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  useEffect(() => {
    fetchClientes();
  }, [fetchClientes]);

  // Aplanar el array de imágenes y conservar info relevante
  const allImages = clientes
    ? clientes.flatMap((cliente) =>
        (cliente.img || []).map((imagen) => ({
          url: imagen.url,
          alt: cliente.nombre || "Cliente",
          opacidad: imagen.opacidad || "",
        }))
      )
    : [];
  // Función para mezclar el array (Fisher-Yates)
  function shuffle(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function groupWithoutRepeats(array, groupSize) {
    const arr = shuffle(array);
    const result = [];
    let i = 0;
    while (i < arr.length) {
      let group = [];
      let localUsed = new Set();
      while (group.length < groupSize && i < arr.length) {
        const img = arr[i];
        const key = img.url;
        if (!localUsed.has(key)) {
          group.push(img);
          localUsed.add(key);
        }
        i++;
      }

      if (group.length < groupSize) {
        for (let j = 0; j < arr.length && group.length < groupSize; j++) {
          const key = arr[j].url;
          if (!localUsed.has(key)) {
            group.push(arr[j]);
            localUsed.add(key);
          }
        }
      }
      result.push(group);
    }
    return result;
  }

  const local = "https://api.institucional.global.sidom.io";

  return (
    <div className="w-full  bg-sidom-blue flex flex-col items-center justify-center">
      <div
        data-aos="fade-up"
        data-aos-delay="100"
        className="container  mt-[100px]   "
      >
        <h2 className="text-sidom-orange text-4xl md:text-5xl font-extrabold w-full   text-left mb-[60px]">
          Clientes
        </h2>
      </div>
      <div className="container  ">
        {allImages.length > 0 && (
          <div className="mb-2">
            <Swiper
              spaceBetween={30}
              slidesPerView={5}
              loop={true}
              speed={7000}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: true,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: { slidesPerView: 3 },
                640: { slidesPerView: 6 },
                1024: { slidesPerView: 8 },
              }}
              className="w-full "
            >
              {groupWithoutRepeats(allImages, 8)
                .flat()
                .map((marca, idx) => (
                  <SwiperSlide
                    key={marca.url + idx}
                    className="flex items-center justify-center"
                  >
                    <img
                      data-aos="fade-up"
                      data-aos-delay="100"
                      src={`${local}${marca.url}`}
                      alt={marca.alt}
                      className={`h-20 md:h-24 object-contain  transition duration-300 mx-auto rounded-lg shadow ${marca.opacidad}`}
                      style={{ maxWidth: "160px" }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        )}
      </div>
      {/* Repetir para los otros Swiper, cambiando reverseDirection si corresponde */}
      <div className="container  ">
        {allImages.length > 0 && (
          <div className="mb-2">
            <Swiper
              spaceBetween={30}
              slidesPerView={5}
              loop={true}
              speed={7000}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: { slidesPerView: 3 },
                640: { slidesPerView: 6 },
                1024: { slidesPerView: 8 },
              }}
              className="w-full "
            >
              {groupWithoutRepeats(allImages, 8)
                .flat()
                .map((marca, idx) => (
                  <SwiperSlide
                    key={marca.url + idx + "b"}
                    className="flex items-center justify-center"
                  >
                    <img
                      data-aos="fade-up"
                      data-aos-delay="100"
                      src={`${local}${marca.url}`}
                      alt={marca.alt}
                      className={`h-20 md:h-24 object-contain  transition duration-300 mx-auto rounded-lg shadow ${marca.opacidad}`}
                      style={{ maxWidth: "160px" }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        )}
      </div>
      <div className="container    ">
        {allImages.length > 0 && (
          <div className="mb-2">
            <Swiper
              spaceBetween={30}
              slidesPerView={5}
              loop={true}
              speed={7000}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: true,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: { slidesPerView: 3 },
                640: { slidesPerView: 6 },
                1024: { slidesPerView: 8 },
              }}
              className="w-full "
            >
              {groupWithoutRepeats(allImages, 8)
                .flat()
                .map((marca, idx) => (
                  <SwiperSlide
                    key={marca.url + idx + "c"}
                    className="flex items-center justify-center"
                  >
                    <img
                      data-aos="fade-up"
                      data-aos-delay="100"
                      src={`${local}${marca.url}`}
                      alt={marca.alt}
                      className={`h-20 md:h-24 object-contain  transition duration-300 mx-auto rounded-lg shadow ${marca.opacidad}`}
                      style={{ maxWidth: "160px" }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        )}
      </div>
      <div className="container mb-[100px]  ">
        {allImages.length > 0 && (
          <div className="mb-2">
            <Swiper
              spaceBetween={30}
              slidesPerView={5}
              loop={true}
              speed={7000}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: { slidesPerView: 3 },
                640: { slidesPerView: 6 },
                1024: { slidesPerView: 8 },
              }}
              className="w-full "
            >
              {groupWithoutRepeats(allImages, 8)
                .flat()
                .map((marca, idx) => (
                  <SwiperSlide
                    key={marca.url + idx + "d"}
                    className="flex items-center justify-center"
                  >
                    <img
                      data-aos="fade-up"
                      data-aos-delay="100"
                      src={`${local}${marca.url}`}
                      alt={marca.alt}
                      className={`h-20 md:h-24 object-contain  transition duration-300 mx-auto rounded-lg shadow ${marca.opacidad}`}
                      style={{ maxWidth: "160px" }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
}
